export default __webpack_public_path__ + "static/media/2023_zonaexpo_ies.52e77d3a.jpg";